import { DataBean } from "../DataBean";

export class AddAccountToDashBoard extends DataBean {



    public async addAccountToDashBoard(idDashBoard: any, idAccount: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.bi.DashBoardAccount_addAccountToDashBoard_Number_Number", [idDashBoard, idAccount]);
    }

}
